module.exports = __webpack_public_path__ + "img/sdoh.487f9d98.jpg";